import { MotionConfig } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/landing/Header';
import { Hero } from '@/components/landing/Hero';
import { StatsBand } from '@/components/landing/StatsBand';
import { ParticleConstellation } from '@/components/landing/ParticleConstellation';
import { Services } from '@/components/landing/Services';
import { Consultoria } from '@/components/landing/Consultoria';
import { Agro } from '@/components/landing/Agro';
import { About } from '@/components/landing/About';
import { Futuro } from '@/components/landing/Futuro';
import { AppMockup } from '@/components/landing/AppMockup';
import { Kits } from '@/components/landing/Kits';
import { Clients } from '@/components/landing/Clients';
import { Coverage } from '@/components/landing/Coverage';
import { Testimonials } from '@/components/landing/Testimonials';
import { Contact } from '@/components/landing/Contact';
import { Footer } from '@/components/landing/Footer';
import { PWAInstallBanner } from '@/components/landing/PWAInstallBanner';
import { WhatsAppFloat } from '@/components/landing/WhatsAppFloat';
import { Section, SectionTitle } from '@/components/landing/Section';
import { QuotationWizard } from '@/components/landing/QuotationWizard';

const DESCRIPTION =
  'Seguridad integral para tu hogar, negocio y campo en Paraguay: guardias capacitados, tecnología y monitoreo 24/7. Solicitá tu presupuesto.';

export function LandingPage() {
  return (
    <MotionConfig reducedMotion="user">
      <Helmet>
        <html lang="es" />
        <title>VISEP — Seguridad Integral</title>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content="VISEP — Seguridad Integral" />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://visep.com.py" />
        <meta property="og:image" content="https://visep.com.py/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="VISEP — Seguridad Integral" />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content="https://visep.com.py/og-image.png" />
      </Helmet>

      {/* Landing é dark fixo (bg literal): imune ao `.light` do ThemeProvider do painel */}
      <div className="min-h-screen bg-[#060B16] text-slate-50">
        <ParticleConstellation />
        <Header />
        <main className="relative z-10 selection:bg-primary selection:text-black">
          <Hero />
          <StatsBand />
          <Services />
          <Consultoria />
          <Agro />
          <About />
          <Futuro />
          <AppMockup />
          <Kits />
          <Clients />
          <Coverage />
          <Testimonials />

          <Section id="quotation" className="border-y">
            <SectionTitle subtitle="Responda unas breves preguntas y obtenga un presupuesto estimado al instante.">
              Solicite su Presupuesto
            </SectionTitle>
            <QuotationWizard />
          </Section>

          <Contact />
        </main>
        <Footer />
        <PWAInstallBanner />
        <WhatsAppFloat />
      </div>
    </MotionConfig>
  );
}
